import CommonHomeCard from "../../components/commonHomeCard";
import ExperienceIcon from "../../components/experience-icon";
import { useDispatch, useSelector } from "react-redux";
import { toggleForm } from "../../redux/ActionCreator";
import { formNames } from "../../components/forms/Validation";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import useIsMobile from "../../hooks/useIsMobile";
import RablaTerms from "../../components/rabla/rablaTerms";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import OfferGrid from "../../components/preference-program/OfferGrid";
import React, { useEffect, useState } from "react";
import TestimonialSlider from "../../components/testimonial/TestimonialSlider";
import { configuration } from "../../helpers/config";
import LinkButton from "../../components/button";
import { CarPageAllSections } from "../pages/templates/all_components";
import { useRouter } from "next/router";
import TopicSlider from "../../components/topics/topicSlider";
import Head from "next/head";
import axios from "axios";
import HomeBanners from "../../components/homebanners";
import { Constants } from "../../helpers/constants";
import FindPerfectSuzuki from "../../components/find-suzuki/findPerfectSuzuki";

const MultiDealerPage = ({
  data,
  testimonials,
  modelData,
  bannerThemeData,
  lob,
  lobData,
}) => {
  const [isTermsModalVisible, setTermsModalVisibility] = useState(false);
  const [pageUrl, setPageUrl] = useState("");
  const [formsData, setFormsData] = useState(null);
  const [distributorData, setDistributorData] = useState(null);
  const LobValue = useSelector(({ app }) => app.LobValue);
  const mobile = useIsMobile();
  const router = useRouter();
  const reduxData = useSelector(({ app }) => app);
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };
  const dispatch = useDispatch();
  const topCta = data?.cta_list?.filter((item) => item?.cta_title === "top");
  const bottomCta = data?.cta_list?.filter(
    (item) => item?.cta_title === "bottom",
  );
  const perfectSuzuki = data?.cta_list?.filter(
    (item) => item?.cta_title === "perfect_suzuki",
  );
  let sortedSliderdata = data?.sliders?.sort(function (a, b) {
    return a.order_index - b.order_index;
  });

  // const topics = data?.placeholder.filter(
  //   (item) => item?.title?.toLowerCase() === "topics",
  // );

  /*const sortedTestimonials = testimonials?.sort(function (a, b) {
    return a.order_index - b.order_index;
  });
*/
 const sortedTestimonials = Array.isArray(testimonials) 
  ? testimonials.sort(function (a, b) {
      return a.order_index - b.order_index;
    })
  : [];
  
  useEffect(() => {
    setPageUrl(window.location.origin);
  }, []);

  useEffect(() => {
    if (reduxData.dealerCode != "") {
      (async () => {
        try {
          const res = await axios.get(
            `${configuration.APP_URL_CONTENTS}/forms?lob=${configuration.API_LOB}&dealer_code=${reduxData.dealerCode}`,
            configuration.HEADER_DEALER_LOCATOR_VAPT,
          );
          setFormsData(res.data[0]?.forms);
        } catch (e) {
          //console.log(e.message);
        }
      })();
    }
  }, [reduxData.dealerCode]);

  const getHomePageData = async () => {
    try {
      const response = await fetch(
        `${configuration.APP_URL_CONTENTS}/home-page?lob=${configuration.API_LOB}&dealer_code=${null}`,
        configuration.HEADER_DEALER_LOCATOR_VAPT,
      );
      const data = await response.json();
     // conslole.log("homoe 2", data);
      setDistributorData(data);
    } catch (err) {
    }
  }
  useEffect(() => {
      getHomePageData()
  }, [])

  return (
    <>
      <Head>
        <title>{data?.seo_settings?.meta_title}</title>
        <meta name="description" content={data?.seo_settings?.meta_desc} />
        <meta name="keywords" content={data?.seo_settings?.keywords} />
        <link rel="icon" href={`${configuration.IMG_STATIC_URL}favicon.ico`} />
      </Head>
      {
        data?.homepage_type === 0 ?
          <div className="">
            <HomeBanners banners={distributorData ? distributorData[0]?.banners : []} />
          </div> :
          <div className="bannerSlider mdwSliders">
            <Slider className={``} {...settings}>
              {sortedSliderdata &&
                sortedSliderdata?.map((elem, index) => {
                  return (
                    <div key={index} className="relative container-fluid mdw_home">
                      <div className="banner-container">
                        <CommonHomeCard
                          cardClassName={"banner_card"}
                          imgSrc={ elem?.image? `${configuration.IMG_URL}${elem?.image}` : ""}
                          imgWidth={1928}
                          imgHeight={1070}
                          imgMobileSrc={elem?.image_mob? `${configuration.IMG_URL}${elem?.image_mob}` : "" }
                          imgMobileWidth={768}
                          imgMobileHeight={1230}
                          cardTitle={elem?.title}
                          cardDescription={elem?.desc}
                          cardBtnText={elem?.ctaText}
                          cardLink={elem?.ctaLink}
                          btnType={"button_light_arrow"}
                          contentBoxClass={"left-auto"}
                          isBannerClickable={elem?.isBannerClickable}
                          // headClassName={banner1ThemeData?.titleColor}
                          // descriptClass={banner1ThemeData?.descColor}
                          bannerTheme={bannerThemeData}
                        // contentBoxClass={
                        //   banners ? "md:bottom-[190px]" : "bottom-[60px]"
                        // }
                        // target={banners?.[0]?.target}
                        />
                      </div>
                    </div>
                  );
                })}
            </Slider>
          </div>
      }

      {/* <HomeBanners banners={distributorData ? distributorData[0]?.banners : []} /> */}

      <div className="container-fluid md:mt-[70px] mt-[60px]">
        <div className="container">
          <h1 className="text-primary-blue font-suzukiBold text-heading mb-[20px]">
           {Constants.homePage.TEXT} 
          </h1>
          <div className="grid grid-cols-2 mb-10 md:grid-cols-4 lg:grid-cols-4">
            {topCta?.[0]?.cta_list?.map((item, idx) => {
              const isForm =
                item.form != null && item.form != "text" && item.form != "";

              return (
                <ExperienceIcon
                  key={idx}
                  icon={
                    item.image
                      ? item.image? `${configuration.IMG_URL}${item.image}` : ""
                      : "/assets/images/brand-pages/experience-icons/add_location_alt.svg"
                  }
                  title={item.cta_name}
                  href={
                    isForm
                      ? null
                      : item.cta_link.includes("http") ||
                        item.cta_link.includes("https")
                        ? item.cta_link
                        : `${pageUrl}${item.cta_link}` // Ensure there's no double slash issue
                  }
                  target={item?.cta_target === "true" ? "_blank" : "_self"}
                  onClick={(e) => {
                    // Prevent default if it's going to be handled here
                    if (
                      isForm ||
                      item.cta_name.toLowerCase() === "configurator"
                    ) {
                      e.preventDefault();
                    }
                    if (
                      isForm &&
                      item.cta_name.toLowerCase() !== "configurator"
                    ) {
                      dispatch(toggleForm(item.form));
                    } else if (
                      !isForm &&
                      item.cta_name.toLowerCase() === "configurator"
                    ) {
                      const urlWithParams = `${item.cta_link.includes("http") ? "" : pageUrl}${item.cta_link}`;
                      // Push the constructed URL with correct condition check
                      router.push(urlWithParams);
                    } else {
                      // If not a form and cta_name is not "configurator", rely on href for navigation
                      // The default click behavior should handle it, as we're not preventing it in this case
                    }
                  }}
                />
              );
            })}

            {/*<ExperienceIcon*/}
            {/*  icon="/assets/images/floatbar/pesoCurrency.svg"*/}
            {/*  title={"Configurator"}*/}
            {/*  // onClick={() => dispatch(toggleForm(formNames.CALC_PAYMENT))}*/}
            {/*/>*/}
          </div>
        </div>
      </div>

      {/* <div className="perfectSuzuki__container container-fluid"> */}
        {/* <div className="container mx-auto">
          <h3 className="perfectSuzuki__container--sectionHeading container-fluid">
           {Constants.homePage.HOMEPAGE_SUZUKI}
          </h3>
        </div> */}
                  {/* find your perfect suzuki section */}
                  
                  <div className="scroll-mt-[5rem]" id="find-perfect-suzuki">
                    {distributorData && (
                      <FindPerfectSuzuki
                        sectionHeading={Constants.homePage.HOMEPAGE_SUZUKI}
                        // cars={props.data[0]?.cars}
                        carsData={distributorData? distributorData[0].cars: []}
                        modelsData={modelData}
                        perfectSuzuki={perfectSuzuki}
                      />
                    )}
                  </div>
        {/* <div className="perfectSuzuki__container--tabs container">
          <Tabs>
            <TabList>
              {modelData?.map(
                (item, i) =>
                  item.tab?.length > 0 && <Tab key={i}>{item?.tab}</Tab>,
              )}
            </TabList>

            {modelData?.map((elem, indx) => {
              return (
                <TabPanel key={indx}>
                  <div className="models-grid-wrapper grid gap-x-[30px] gap-y-[30px] md:gap-x-[35px] md:gap-y-[70px] grid-cols-2 md:grid-cols-4 lg:grid-cols-4">
                    {elem?.modelData?.map((elems, indx) => {
                      return (
                        <OfferGrid
                          key={indx}
                          image={ elems.images.desk_small? `${configuration.IMG_URL}${elems.images.desk_small}`: "" }
                          prices
                          startPrice={elems?.startPrice}
                          RablaPrice
                          RablaPricing={elems?.RablaPricing}
                          offerPrices
                          offerPricing={elems?.offerPricing}
                          model={elems?.model_name}
                          HUF
                          perMonth
                          fullBorderCtas
                          btnText={"Know More"}
                          cardLink={`${router.pathname}/${LobValue === 1
                            ? `cars/${elems?.page_url}`
                            : LobValue === 2
                              ? `bike/${elems?.page_url}`
                              : LobValue === 3
                                ? `marine/${elems?.page_url}`
                                : ""
                            }`}
                          perfectSuzuki={perfectSuzuki}
                        />
                      );
                    })}
                  </div>
                </TabPanel>
              );
            })}
          </Tabs>
        </div> */}
        {process.env.NEXT_PUBLIC_COUNTRY_CODE !== "VNM" && (
        <div className="container-fluid container md:mt-[100px] mt-[50px] mb-[50px]">
          <div className="md:container">
            <h2
              className="underline text-primary-blue uppercase font-suzukiBold cursor-pointer text-sub-heading"
              onClick={() => setTermsModalVisibility(true)}
            >
              {Constants.homePage.TERMS_AND_CONDITION}
            </h2>
          </div>
        </div>
        )}
        
        {isTermsModalVisible && (
          <RablaTerms
            open={isTermsModalVisible}
            onClose={() => setTermsModalVisibility(false)}
            termspara1="Ofertă fără valoare contractuală, supusă unor termene și condiții valabilă în limita stocului disponibil. Prețurile de listă reprezintă prețuri de vânzare recomandate și nu includ valoarea oricăror echipamente, accesorii sau dotări opționale. Magyar Suzuki ZRT Esztergom Sucursală își rezervă dreptul de a modifica lista de specificatii si lista de prețuri ca urmare a unor erori, modificări structurale sau în urma unor comunicări din partea producătorului, fără nicio informare prealabilă. Din acest motiv ele nu pot fi considerate drept angajamente contractuale. Relațiile comerciale se desfasoară prin intermediul dealerilor rețelei Suzuki. Relațiile tranzacționale se efectuează în LEI la cursul valutar practicat de către dealerul Suzuki. Pentru a obține o ofertă de actualitate, este necesar să vă adresați unui dealer Suzuki. Au fost depuse toate eforturile rezonabile astfel încât informațiile, descrierile și imaginile prezentate să fie cele corecte la momentul publicării lor. De asemenea imaginile autoturismelor prezente sunt cu titlu de prezentare, vehiculele comercializate efectiv având dotări și accesorizări diferite, în funcție de nivelul de echipare al fiecăruia. Un ghid conținând date privind consumul de carburant și emisiile de CO₂ pentru toate modelele de autoturisme noi poate fi obținut în rețeaua autorizată Suzuki România. Oferta Rabla este aplicabilă prin PSIPAN, derulat de Administrația Fondului pentru Mediu și finanțat din Fondul pentru Mediu, sub rezerva îndeplinirii de către client a tuturor condițiilor impuse de Ghidul de Finantare PSIPAN și a acceptării dealerilor autorizați Suzuki ca producători validați în program. Oferta Rabla este destinatat persoanelor fizice si este supusă unor termene și condiții valabilă în limita stocului disponibil. Aceasta presupune aplicarea primei de casare și a ecobonusului/ecobonusurilor calculate în Euro (1 € = 5 LEI) și nu include echipamente, accesorii sau dotări opționale. Avantajul maxim se poate obține în cazul achiziției unei versiuni Hybrid cu emisii CO2 mai mici sau egale cu 120 g/km în sistem WLTP și prin casarea a 2 (două) vehicule cu o vechime de cel puțin 15 ani de la data fabricației și cu norma de poluare Euro 3 sau inferioară. Pentru mai multe detalii consultați dealerii Suzuki. Prețul este obținut prin aplicarea primei de casare de 10,000 Lei în schimbul casarii a 2 (două) autovehicule uzate și prin aplicarea Ecobonusurilor în valoare totală de 7,500 Lei formate din: 1,500 Lei pentru versiunile cu emisii CO2 mai mici sau egale cu 120 g/km în sistem WLTP , 3,000 Lei pentru casarea a 2 (două) vehicule cu o vechime de cel puțin 15 ani de la data fabricației și cu normă de poluare Euro 3 sau inferioară și 3,000 Lei pentru autovehiculele Hybrid (echipate cu sistem de propulsie Hybrid)"
          />
        )}
      {/* </div> */}

      <div>
        {sortedTestimonials && sortedTestimonials?.length > 0 && (
          <TestimonialSlider
            showHeading={true}
            data={sortedTestimonials}
            pageType="homepage"
            fullBorderCtas
          />
        )}
      </div>
      <div className="flex justify-center items-center gap-5">
        {bottomCta?.[0]?.cta_list?.map((item, idx) => {
          const isForm =
            item.form != null && item.form != "text" && item.form != "";
          return (
            <div
              key={idx}
              className="fullBorder-ctas compareItem__CTAs mt-[50px] flex-row md:flex hidden"
            >
              <LinkButton
                buttontext={item?.cta_name}
                href={
                  isForm
                    ? null
                    : item.cta_link.includes("http") ||
                      item.cta_link.includes("https")
                      ? item.cta_link
                      : pageUrl + item.cta_link
                }
                target={item?.cta_target == "true" ? "_blank" : "_self"}
                type={"button_dark_arrow_button"}
                onClick={() =>
                  isForm ? dispatch(toggleForm(item.form)) : false
                }
                widthManage={"min-w-[230px]"}
              />
            </div>
          );
        })}
      </div>
      <div className="topics__container pr-[40px]">
         {data?.placeholder.length > 0 && (
          data.placeholder.map((topic)=>{
          return<> <h5 className="topics__container--heading">{topic?.title}</h5>
           <TopicSlider showHeading={false} data={topic?.pages} type={topic?.type} column={topic.column} 
          image={topic.isImage}
          cta={topic?.[0]}
          />
          </>
          })
        )}
      </div>
    </>
  );
};

export default MultiDealerPage;
